import { render, staticRenderFns } from "./supplierAuditList.vue?vue&type=template&id=42555048"
import script from "./supplierAuditList.vue?vue&type=script&lang=js"
export * from "./supplierAuditList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports